import { render, staticRenderFns } from "./BookDeliveryPage.vue?vue&type=template&id=ad38c208&scoped=true"
import script from "./BookDeliveryPage.vue?vue&type=script&lang=js"
export * from "./BookDeliveryPage.vue?vue&type=script&lang=js"
import style0 from "./BookDeliveryPage.vue?vue&type=style&index=0&id=ad38c208&prod&lang=css"
import style1 from "./BookDeliveryPage.vue?vue&type=style&index=1&id=ad38c208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad38c208",
  null
  
)

export default component.exports